
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue'
import Header from './components/Header.vue'
import NavMenuDesktop from './components/NavMenuDesktop.vue'
import NavMenuMobile from './components/NavMenuMobile.vue'

export default defineComponent({
  name: 'AppMain',
  components: {
    Header,
    NavMenuDesktop,
    NavMenuMobile
  },
  setup () {
    const windowWidth = ref(window.innerWidth)
    const vh = ref(window.innerHeight * 0.01)
    document.documentElement.style.setProperty('--vh', `${vh.value}px`)

    const onResize = () => {
      windowWidth.value = window.innerWidth
      vh.value = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh.value}px`)
    }
    onMounted(() => {
       window.addEventListener('resize', onResize)
    })
    onBeforeUnmount(() => {
      window.removeEventListener('resize', onResize)
    })
    return {
      windowWidth
    }
  }
})
